import { BaseBlock } from "./BaseBlock";

export class ProductTitleBlock
    extends BaseBlock {

    private readonly title: string;

    private root!: HTMLElement;

    constructor(
        title: string
    ) {

        super();

        this.title = title;

    }

    public override mount(): void {

        this.root =
            document.createElement("div");

        this.root.className =
            "subscriptions-title";

        const h2 =
            document.createElement("h2");

        h2.textContent =
            this.title;

        this.root.appendChild(
            h2
        );

    }

    public getRoot(): HTMLElement {

        return this.root;

    }

}